import React, { useMemo } from 'react';

import ClearSelectedKbItem from 'actions/composition/clear_selected_kb_item';
import connect from 'components/lib/connect';

export const DEFAULT_COMPOSER_CONTEXT = {
  answerToInsert: undefined,
  clearInsertedAnswer: () => {},
  composition: undefined,
};
const ComposerContext = React.createContext(DEFAULT_COMPOSER_CONTEXT);
export default ComposerContext;

export function ComposerContextProviderBase({
  answerToInsert,
  children,
  composition,
  compositionErrors,
  compositionErrorsImm,
  clearInsertedAnswer,
  isMinimized,
}) {
  const value = useMemo(
    () => ({
      answerToInsert,
      clearInsertedAnswer,
      composition,
      compositionErrors,
      isMinimized,
    }),
    // We use the errors immutable as an indication that compositionErrors has changed, since we recreate the errors array each
    // time the container re-renders (this happens in the store).
    [answerToInsert, clearInsertedAnswer, composition, compositionErrorsImm, isMinimized]
  );

  return <ComposerContext.Provider value={value}>{children}</ComposerContext.Provider>;
}

const ComposerContextProvider = connect(mapStateToProps, mapExecuteToProps)(ComposerContextProviderBase);
export { ComposerContextProvider };

function mapStateToProps({ getProvider, isFeatureEnabled }, { composition }) {
  const selectedKbItem = getProvider('selectedKbItem').get();
  const compositionsProvider = getProvider('compositions');

  return {
    answerToInsert: selectedKbItem,
    compositionErrors: compositionsProvider.getErrors(composition.id),
    compositionErrorsImm: compositionsProvider.immutableStore.binding.get([composition.id, '_errors']),
    isMinimized: getProvider('currentLocation').get().isCompositionMinimized,
  };
}

let clearInsertedAnswer;

function mapExecuteToProps(executeAction) {
  if (!clearInsertedAnswer) {
    clearInsertedAnswer = () => executeAction(ClearSelectedKbItem);
  }

  return {
    clearInsertedAnswer,
  };
}



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/composer/contexts/composer_context.jsx